module.exports = __webpack_public_path__ + "static/media/galaxy-tracer.dcbd5b54.png";